import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthService, UserService } from '@doddly/core';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';

@Component({
  standalone: true,
  imports: [RouterModule, ToastModule],
  providers: [MessageService],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private userService: UserService,
  ) {}

  ngOnInit(): void {
    this.authService.user$.subscribe((user) => {
      if (user) {
        this.userService.currentUserSig.set(
          this.userService.getUserPayload(user),
        );
        user.getIdToken(true).then((token: string) => {
          this.userService.setToken(token);
        });
      } else {
        this.userService.currentUserSig.set(null);
        this.userService.setToken(null);
      }
    });
  }
}
